import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum, type RumEvent } from '@datadog/browser-rum';

import type { DatadogRumContext, Environment } from '../types';

export const isDataDogRUMEnabled = () =>
  datadogRum &&
  Number(datadogRum.getInitConfiguration()?.sessionSampleRate) > 0;

export const track = (e: Error | string | any): void => {
  if (isDataDogRUMEnabled()) {
    if (e instanceof Error) {
      datadogRum.addError(e);
    } else {
      datadogRum.addError({
        message: typeof e === 'string' ? e : 'Unknown error',
        source: 'custom',
        stack: typeof e === 'object' && e.stack ? e.stack : '',
      });
    }
  } else {
    // eslint-disable-next-line no-console
    console.error(e);
  }
};

export const logError = (error: unknown, context?: object | string): void => {
  if (isDataDogRUMEnabled()) {
    datadogRum.addError(
      error,
      typeof context === 'string' ? { message: context } : context,
    );
  } else {
    // eslint-disable-next-line no-console
    console.error(error);
  }
};

export const beforeSend = (event: RumEvent) =>
  !(
    event.type === 'error' &&
    /^401 : POST https:\/\/(?:[\w.])*\/usernamepassword\/login$/.test(
      event.error.message,
    )
  );

export const configureErrorTracking = (
  environment: Environment,
  context: DatadogRumContext,
) => {
  try {
    if (isDataDogRUMEnabled()) {
      return;
    }

    datadogRum.init({
      applicationId: '2deb02a9-ca55-4029-8ae2-bf3a67b13278',
      clientToken: 'pubb37fcd334b345135a3497728cc3f77f0',
      site: 'datadoghq.com',
      service: 'online-identity-temp',
      env: environment,
      version: context.version,
      sessionSampleRate: 10,
      sessionReplaySampleRate: 2,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input',
      beforeSend,
    });

    datadogLogs.init({
      clientToken: 'pubb37fcd334b345135a3497728cc3f77f0',
      site: 'datadoghq.com',
      env: environment,
      version: context.version,
      sessionSampleRate: 10,
      forwardErrorsToLogs: true,
    });

    datadogRum.setGlobalContext(context);
    datadogLogs.setGlobalContext(context);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('An error occurred setting up error reporting', error);
  }
};
